import React from 'react'

import Routes from './routes'

const Settings = () => {
  return <Routes />
}

export default Settings
